import { ImageViewerImage } from "@omni/types/api/product/bff/shared/imageViewerImage.model";
import { ImageViewerVideo } from "@omni/types/api/product/bff/shared/imageViewerVideo.model";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as ImageViewerModule from "@/redux/modules/value/imageViewer/imageViewer.module";
import * as ImageViewerSelectors from "@/redux/modules/value/imageViewer/imageViewer.selectors";
import { withBreakpoints } from "@/utils/breakpoints/breakpoints.provider";

import { ImageViewerFullWidthComponent } from "./imageViewerFullWidth.component";

export type ImageViewerFullWidthProps = {
    className?: string;
    images: Array<ImageViewerImage>;
    videos: Array<ImageViewerVideo>;
    defaultVideoThumbnailPath?: string;
};

const _ImageViewerFullWidth = ({
    className,
    images,
    videos,
    defaultVideoThumbnailPath
}: ImageViewerFullWidthProps) => {
    const activeIndex = useSelector(ImageViewerSelectors.getActiveIndex);
    const dispatch = useThunkDispatch();
    const setActiveIndex = (index: number) => {
        dispatch(ImageViewerModule.update({ activeIndex: index }));
    };

    return (
        <ImageViewerFullWidthComponent
            className={className}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            images={images || []}
            videos={videos || []}
            defaultVideoThumbnailPath={defaultVideoThumbnailPath}
        />
    );
};

export const ImageViewerFullWidth = withBreakpoints(
    _ImageViewerFullWidth,
    () => null
);
